export const PATHS = {
  ROOT: 'partners-introductions',
  getOneById: (id: number) => `${PATHS.ROOT}/${id}`,
};
